module.exports = "/_next/static/images/value-voucher-c01a78a035ee00a6cf96a16c0ca46ef7.svg";